var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "events-wrapper" }, [
    _vm.isEventsLoading
      ? _c("div", [_c("generic-loading-skeleton")], 1)
      : _c("div", [
          _c(
            "div",
            { staticClass: "d-flex justify-content-between pb-2" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("edit-event-interests-button", {
                staticClass: "pt-1",
                attrs: { topics: _vm.topics, showSubtitle: true },
                on: { interestsSaved: _vm.resetEventsFeed }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.events && _vm.events.length > 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "pt-1" },
                  _vm._l(_vm.events, function(event) {
                    return _c("div", { key: event.id }, [
                      _c(
                        "div",
                        { staticClass: "pb-2 pl-1" },
                        [_c("event-card", { attrs: { "event-data": event } })],
                        1
                      )
                    ])
                  }),
                  0
                )
              ])
            : _c("div", [_vm._v("No events to display")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-between" },
            [
              _c(
                "router-link",
                {
                  staticClass: "view-all-link",
                  attrs: { to: { path: "events" } },
                  nativeOn: {
                    click: function($event) {
                      return _vm.trackViewAllEvent()
                    }
                  }
                },
                [_c("span", [_vm._v("View all")])]
              )
            ],
            1
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h2", [_vm._v("Events")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ae12560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae12560","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/events/Events.vue
// module id = null
// module chunks = 